import { useState } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { LanguageSwitcher } from '@/components/LanguageSwitcher'
import { useLocale } from '@/i18n/LocaleProvider'
import { useAuth } from '@/lib/auth'
import curlyLogo from '@/assets/brand/curly-logo.jpg'

export function Login() {
  const { isAuthenticated, isLoading, login } = useAuth()
  const { t } = useLocale()
  const location = useLocation()
  const from = (location.state as { from?: string } | null)?.from ?? '/'
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  if (isLoading) {
    return <div className="flex min-h-screen items-center justify-center text-sm text-slate-500">{t('login.checking')}</div>
  }
  if (isAuthenticated) return <Navigate to={from} replace />

  return (
    <div className="mma-login flex min-h-dvh items-center justify-center overflow-y-auto px-4 py-6">
      <form
        className="mma-login-frame w-full max-w-sm rounded-lg border border-surface-border bg-surface-raised p-6"
        onSubmit={(event) => {
          event.preventDefault()
          setBusy(true)
          setError(null)
          void login(email, password)
            .catch((err: unknown) => {
              setError(err instanceof Error ? err.message : t('login.failed'))
            })
            .finally(() => setBusy(false))
        }}
      >
        <div className="flex items-center gap-3">
          <img src={curlyLogo} alt="CURLY" className="brand-logo" />
          <div>
            <h1 className="mma-login-title text-lg font-semibold">P2P Curly трекер</h1>
            <p className="mt-0.5 text-sm text-slate-500">{t('login.subtitle')}</p>
          </div>
        </div>
        <LanguageSwitcher />
        <p className="mt-4 text-sm text-slate-500">{t('login.lead')}</p>
        <label className="mt-5 block text-xs text-slate-400">
          {t('login.email')}
          <input
            type="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            className="mma-login-input mt-1 w-full rounded-md border border-surface-border bg-surface px-3 py-2 text-slate-100"
            autoComplete="username"
            required
          />
        </label>
        <label className="mt-3 block text-xs text-slate-400">
          {t('login.password')}
          <input
            type="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            className="mma-login-input mt-1 w-full rounded-md border border-surface-border bg-surface px-3 py-2 text-slate-100"
            autoComplete="current-password"
            required
          />
        </label>
        {error && <p className="mt-3 text-sm text-loss">{error}</p>}
        <button type="submit" disabled={busy} className="cabin-cta mt-5">
          {busy ? t('login.busy') : t('login.submit')}
        </button>
        <p className="mt-4 text-center text-xs text-slate-500">
          <a href="/privacy" className="underline">
            {t('login.privacy')}
          </a>
        </p>
      </form>
    </div>
  )
}
